<template>
  <v-flex class="admin-page" >
    <v-tabs style="flex:0 0 auto;" slider-color="#ddd">
      <v-tab v-if="userSecurity[SecurityItemsKeys.HOME_MAINTENANCE].enable" exact ripple :to="{name:'Maintenance'}">
        {{$t('Admin.Menu')}}
      </v-tab>      
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_GLIDER].enable" ripple :to="{name:'NewGlider'}">
        {{$t('Admin.Glider.Title')}}
      </v-tab>      
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_COMPANY].enable" ripple :to="{name:'NewEnseigne'}">
        {{$t('Admin.Enseigne.Title')}}        
      </v-tab>     
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT_CLASS].enable" ripple :to="{name:'NewUmbClasse'}">
        {{$t('Admin.UmbClasse.Title')}}
      </v-tab>     
       <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT_TYPE].enable" ripple :to="{name:'NewUmbType'}">
         {{$t('Admin.UmbType.Title')}}
      </v-tab>             
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT].enable" ripple :to="{name:'NewUniteMobile'}">
        {{$t('Admin.UniteMobile.Title')}}
      </v-tab>        
       <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_USER].enable" ripple :to="{name:'NewUser'}">
         {{$t('Admin.User.Title')}}
      </v-tab>       
       <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_ROLE].enable" ripple :to="{name:'NewRole'}">
         {{$t('Admin.Role.Title')}}
      </v-tab>       
       <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MESURETYPE].enable" ripple :to="{name:'NewMesureType'}">
         {{$t('Admin.MesureType.Title')}}        
      </v-tab>         
       <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MESUREUNIT].enable" ripple :to="{name:'NewMesureUnite'}">
        {{$t('Admin.MesureUnite.Title')}}        
      </v-tab>  
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MISSION].enable" ripple :to="{name:'NewAdminMission'}">
        {{$t('Admin.AdminMission.Title')}}        
      </v-tab>  
      <!-- <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_FLEET].enable" ripple :to="{name:'NewAdminFleet'}">
        {{$t('Admin.AdminFleet.Title')}}        
      </v-tab>     -->
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_POSITIONREMARQUABLE].enable" ripple :to="{name:'NewPositionRemarquable'}">
        {{$t('Admin.PositionRemarquable.Title')}}        
      </v-tab>     
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MAP_LAYER].enable" ripple :to="{name:'NewMapLayer'}">
        {{$t('Admin.MapLayer.Title')}}        
      </v-tab>     
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_UPLOAD_MISSION].enable" ripple :to="{name:'UploadFile'}">
        {{$t('Admin.UploadFile.Title')}}        
      </v-tab>     
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_COMMAND_COMPLETION].enable" ripple :to="{name:'CmdCompletion'}">
        {{$t('Admin.CmdCompletion.Title')}}        
      </v-tab>      
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_MESSAGE_LOGIN].enable" ripple :to="{name:'MsgAccueil'}">
        {{$t('Admin.MsgAccueil.Title')}}        
      </v-tab>         
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_NMEA_DISPLAY].enable" ripple :to="{name:'Nmea'}">
        {{$t('Admin.Nmea.Title')}}        
      </v-tab>        
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_HOME_IMAGE].enable" ripple :to="{name:'Image'}">
        {{$t('Admin.Image.Title')}}        
      </v-tab>          
      <v-tab v-if="userSecurity[SecurityItemsKeys.ADMIN_PWD_POLICY].enable" ripple :to="{name:'PwdPolicy'}">
        {{$t('Admin.PwdPolicy.Title')}}        
      </v-tab>        
    </v-tabs>     
    <router-view />      
   </v-flex>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { SecurityItemsKeys } from '@/enum/SecurityItems';

@Component({
  name: 'Maintenance', 
})
export default class App extends Vue {  

  beforeRouteEnter(to:any,from:any,next:any) {        
     next((vm:App) => {                      
        if(vm.$store.myGetters.userSecurity[SecurityItemsKeys.HOME_MAINTENANCE].enable) next()
        else next('/login')
     })
  }

  mounted(){
    this.$vuetify.theme.primary = '#00C853'
    this.$vuetify.theme.secondary = '#ec7404'    
  }
  
  get userSecurity(){
    return this.$store.myGetters.userSecurity
  }
  
  get  SecurityItemsKeys(){
    return SecurityItemsKeys
  }

}
</script>

<style>
  .admin-page .v-tabs__item--active{
    background-color:#ddd;
  }  

  .admin-page .v-tabs__item{
    border-right:1px solid #efefef;
  }

  .admin-page{
    background-color:#ddd;
    display: flex;
    flex-direction: column;    
    position: absolute;
    top:0px;
    bottom: 0px;
    left:0px;
    right: 0px;
  }
</style>